<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="100px" class="EL-Form">
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点通道" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点单号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.sckCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点状态" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="sckStatusList" placeholder="请选择" clearable="clearable">
                            <el-option label="已下发" value="LSSUED" />
                            <el-option label="进行中" value="EXECUTE" />
                            <el-option label="待处理" value="HANDLE" />
                            <el-option label="完成" value="COMPLETE" />
                            <el-option label="关闭" value="CLOSE" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点类型" class="EL-Form-Item">
                        <el-select v-model="mainSearch.sckType" placeholder="请选择" clearable="clearable">
                            <el-option label="手动" value="手动" />
                            <el-option label="自动" value="自动" />
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetMain()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
                    <el-form-item label="盘点方式" class="EL-Form-Item">
                        <el-select v-model="mainSearch.sckWay" placeholder="请选择" clearable="clearable">
                            <el-option label="明盘" value="10" />
                            <el-option label="暗盘" value="20" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
                    <el-form-item label="盘点方式" class="EL-Form-Item">
                        <el-select v-model="mainSearch.sckWay" placeholder="请选择" clearable="clearable">
                            <el-option label="明盘" value="10" />
                            <el-option label="暗盘" value="20" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点自动类型" class="EL-Form-Item">
                        <el-select v-model="mainSearch.sckTypeSub" placeholder="请选择" clearable="clearable">
                            <el-option label="物料" value="物料" />
                            <el-option label="月" value="月" />
                            <el-option label="年" value="年" />
                            <el-option label="库位" value="库位" />
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :lg="9" :xl="9">
                    <el-form-item label="时间范围" class="EL-Form-Item">
                        <el-date-picker style="width: 350px" v-model="mainSearch.date" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
                
            </el-form>
        </box>
        <box fill>
            <plabel text="盘点计划">
                <el-button v-authority="'BACK_MENU3_M17_B1'" class="btn-t-edit" @click="whInventoryOpen()">新增</el-button>
                <el-button v-authority="'BACK_MENU3_M17_B2'" class="btn-t-delete" @click="deleteStockCheckTask">删除</el-button>
                <el-button v-authority="'BACK_MENU3_M17_B3'" class="btn-t-edit" @click="prints()">单据打印</el-button>
                <el-button v-authority="'BACK_MENU3_M17_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getStockCheckTaskList" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="checkTableMain">
                <el-table-column type="selection" align="center">
                </el-table-column>
                <!-- <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column> -->
                <el-table-column label="盘点单号" align="center" prop="sckCode" width="150px">
                </el-table-column>
                <!-- <el-table-column label="物料批次" align="center" prop="batchNo">
                </el-table-column> -->
                <!-- <el-table-column label="盘点类型" align="center" prop="sckType">
                </el-table-column> -->
                <el-table-column label="盘点状态" align="center" prop="sckStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sckStatus == 'LSSUED'">已下发</span>
                        <span v-if="scope.row.sckStatus == 'EXECUTE'">进行中</span>
                        <span v-if="scope.row.sckStatus == 'HANDLE'">待处理</span>
                        <span v-if="scope.row.sckStatus == 'COMPLETE'">完成</span>
                        <span v-if="scope.row.sckStatus == 'CLOSE'">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="盘点部门" align="center" prop="sckDept">
                </el-table-column>
                <el-table-column label="盘点人员" align="center" prop="sckPerson">
                </el-table-column>
                <el-table-column label="盘点方式" align="center" prop="sckWay">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sckWay == '10'">明盘</span>
                        <span v-if="scope.row.sckWay == '20'">暗盘</span>
                    </template>
                </el-table-column>
                <el-table-column label="预计盘点时间" align="center" prop="sckTime" width="240px">
                </el-table-column>
                <el-table-column label="是否重盘" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.reloadFlag == true">是</span>
                        <span v-if="scope.row.reloadFlag == false">否</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime" width="150px">
                </el-table-column>
                <el-table-column label="修改时间" align="center" prop="updateTime" width="150px">
                </el-table-column>
                <el-table-column label="操作人" align="center" prop="person">
                </el-table-column>
                <el-table-column label="操作" min-width="130" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU3_M17_B5'" class="btn-t-edit" @click="rowDetail(scope.row.sckCode)">详情</el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 编辑框 -->
        <el-dialog title="编辑" :visible.sync="updateShow" class="fromDialog" :close-on-click-modal="false" :show-close="false">
            <div>
                <el-form label-position="right" label-width="100px">
                    <el-col :span="12">
                        <el-form-item label="通道">
                            <el-input v-model="updateDialogData.whCode" disabled></el-input>
                            <!-- <el-select
                v-model="updateDialogData.whCode"
                clearable="clearable"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in warehouseList"
                  :key="item.whCode"
                  :value="item.whCode"
                  :label="item.whCode + '-' + item.whName"
                ></el-option>
              </el-select> -->
                            <el-select v-model="updateDialogData.whCode" placeholder="请选择" clearable="clearable">
                                <el-option v-for="(item, index) in warehouseList" :key="index" :label="item.whCode" :value="item.whCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="盘点单号">
                            <el-input v-model="updateDialogData.sckCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-select v-model="updateDialogData.sckStatus" placeholder="请选择" disabled>
                                <el-option label="进行中" value="EXECUTE" />
                                <el-option label="完成" value="COMPLETE" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="盘点类型">
                            <el-select v-model="updateDialogData.sckType" placeholder="请选择" clearable="clearable">
                                <el-option label="手动" value="手动" />
                                <el-option label="自动" value="自动" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                        <el-form-item label="盘点自动类型">
                            <el-select v-model="updateDialogData.sckTypeSub" placeholder="请选择" clearable="clearable">
                                <el-option label="物料" value="物料" />
                                <el-option label="月" value="月" />
                                <el-option label="年" value="年" />
                                <el-option label="库位" value="库位" />
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="12">
                        <el-form-item label="盘点方式">
                            <el-select v-model="updateDialogData.sckWay" placeholder="请选择" clearable="clearable">
                                <el-option label="明盘" value="10" />
                                <el-option label="暗盘" value="20" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateClose" type="info">取 消</el-button>
                <el-button @click="updateStockCheckTask()" type="primary">编 辑</el-button>
            </div>
        </el-dialog>

        <!-- 重新盘点-->
        <!-- <el-dialog title="重新盘点" :visible.sync="reloadCheckShow" class="fromDialog" :close-on-click-modal="false" :show-close="false">
            <div>
                <el-form label-position="right" label-width="100px">
                    <el-col :span="16">
                        <el-form-item label="盘点时间">
                            <el-date-picker v-model="relaodCheckTime" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reloadCheckShow = false" type="info">取 消</el-button>
                <el-button @click="reloadCheckTask" type="primary">重新盘点</el-button>
            </div>
        </el-dialog> -->

        <!-- 详情框 -->
        <el-dialog title="详情" :visible.sync="detailShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <div>
                <h-table :headerCellStyle="detailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.8)" :data="detailData.data" pagination :nowPage.sync="detailData.nowPage" :pageSize.sync="detailData.pageSize" :total.sync="detailData.total" @pageChange="getStockCheckTaskDetailList()">
                    <el-table-column label="通道编号" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName">
                    </el-table-column>
                    <el-table-column label="物料数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="实际数量" align="center" prop="matQuanReal">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status == 'EXECUTE'">

                            </div>
                            <div v-else>
                                {{ scope.row.matQuanReal }}   
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="库位" align="center" prop="laCode">
                    </el-table-column>
                    <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                    </el-table-column>
                    <el-table-column label="盘点单号" align="center" prop="sckCode">
                    </el-table-column>
                    <el-table-column label="状态" align="center" prop="status">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 'LSSUED'">已下发</span>
                            <span v-if="scope.row.status == 'EXECUTE'">进行中</span>
                            <span v-if="scope.row.status == 'HANDLE'">待处理</span>
                            <span v-if="scope.row.status == 'COMPLETE'">完成</span>
                            <span v-if="scope.row.status == 'PROCESSED'">完成</span>
                            <span v-if="scope.row.status == 'CLOSE'">关闭</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="备注" align="center" prop="remark">
                    </el-table-column> -->
                    <el-table-column label="订单编号" align="center" prop="orderCode">
                    </el-table-column>
                    <el-table-column label="规值" align="center" prop="matSpecs">
                    </el-table-column>
                    <el-table-column label="创建时间" align="center" prop="createTime">
                    </el-table-column>
                    <el-table-column label="盘点人" align="center" prop="person">
                    </el-table-column>
                    <!-- <el-table-column label="更新时间" align="center" prop="updateTime">
                    </el-table-column> -->
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="detailClose" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 新增盘点 -->
        <el-dialog title="新增盘点" :visible.sync="whInventoryShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <el-form label-position="right" label-width="100px">
                <el-row>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="仓库类型" class="EL-Form-Item">
                            <el-select v-model="warehouseType" placeholder="请选择" clearable="clearable">
                                <el-option v-for="(item, index) in warehouseTypeList" :key="index" :label="item.lmName" :value="item.lmId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点库区" class="EL-Form-Item">
                            <el-cascader v-if="isShowAddressInfo" :key="keyValue" v-model="lcCodeType" :options="inventoryLocationList" :props="optionProps" collapse-tags clearable @change="getLcCodeByType">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="库位" class="EL-Form-Item">
                            <el-select v-model="whInventorySearch.lcCode" placeholder="请选择" clearable="clearable" filterable remote :remote-method="remoteMethodLcCode">
                                <el-option v-for="(item, index) in LcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料类型" class="EL-Form-Item">
                            <el-select v-model="mtType" placeholder="请选择" filterable clearable="clearable">
                                <el-option v-for="(item, index) in matTypeList" :key="index" :label="item.dtCode+ '-' + item.ddName" :value="item.dtCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button :loading="getStockListLoading" class="btn-t-edit" @click="clickSelectDetailList()">查询</el-button>
                            <el-button class="btn-t-delete" @click="resetInsertWhInventory()">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-select v-model="whInventorySearch.matCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethod">
                                <el-option v-for="(item, index) in matCodes" :key="index" :label="item.mtCode" :value="item.mtCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="批次号" class="EL-Form-Item">
                            <el-input v-model="whInventorySearch.batchNo" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点部门" class="EL-Form-Item">
                            <el-select v-model="checkDept" placeholder="请选择" clearable="clearable">
                                <el-option v-for="(item, index) in deptCodeTypeList" :key="index" :label="item.ddName" :value="item.ddName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点人员" class="EL-Form-Item">
                            <el-select v-model="checkPerson" placeholder="请选择" clearable="clearable" filterable>
                                <el-option v-for="(item, index) in userList" :key="index" :label="item.userName" :value="item.userAccount">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button @click="printsSearch()" class="btn-t-delete">打 印</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点方式" class="EL-Form-Item">
                            <el-select v-model="checkSckWay" placeholder="请选择">
                                <el-option label="明盘" value="10" />
                                <el-option label="暗盘" value="20" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="盘点时间" class="EL-Form-Item">
                        <el-date-picker v-model="checkTime" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="第几层" class="EL-Form-Item">
                            <el-select v-model="whInventorySearch.height" multiple="" placeholder="请选择">
                                <el-option label="1" value="1" />
                                <el-option label="2" value="2" />
                                <el-option label="3" value="3" />
                                <el-option label="4" value="4" />
                                <el-option label="5" value="5" />
                                <el-option label="6" value="6" />
                                <el-option label="7" value="7" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点开始日期" class="EL-Form-Item">
                            <el-date-picker v-model="checkTime[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions1"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="盘点结束日期" class="EL-Form-Item">
                            <el-date-picker v-model="checkTime[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions2"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <h-table :headerCellStyle="mainData.headerCellStyle" :style="$popups.harvestRecordStyle(0.57)" @pageChange="getStockList()" :data="whInventoryDialog.data" pagination :nowPage.sync="whInventoryDialog.nowPage" :pageSize.sync="whInventoryDialog.pageSize" :total.sync="whInventoryDialog.total" ref="hTable" @selectionChange="checkAllWh">
                <!-- <el-table-column type="selection" align="center">
                </el-table-column> -->
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="库位" align="center" prop="lcCode">
                </el-table-column>
                <!-- <el-table-column label="订单编号" align="center" prop="orderCode">
                </el-table-column> -->
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs">
                </el-table-column>
                <el-table-column label="物料状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                        <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">人工冻结</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="生产日期" align="center" prop="matCreateTime" width="100px">
</el-table-column> -->
                <el-table-column label="入库时间" align="center" prop="createTime" width="100px">
                </el-table-column>
                <!-- <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="
                            deleteRow(scope.$index, whInventoryDialog.data)
                        " class="btn-t-delete">移除</el-button>
                    </template>
                </el-table-column> -->
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="whInventoryClose()" class="btn-t-info" type="info">取 消</el-button>
                <el-button :loading="insertStockCheckTaskByParams" class="btn-t-edit" @click="insertStockCheckTaskByParam()">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="盘点单打印" :visible.sync="printShow" width="1200px" :close-on-click-modal="false">
            <div style="margin-top:20px;margin-left:800px">
                <el-button class="btn-t-info" type="info" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button>
            </div>
            <v-print :doPrint.sync="print">
                <div id="demo" class="demo">
                    <div>
                        <div style="font-size: 42px;font-weight: 600;margin-top: 25px;text-align: center;color: black;">
                            盘点单
                        </div>
                        <div class="table">
                            <div style="margin-left: -950px;font-size:18px;margin-bottom:20px">
                                {{ timeDate }}
                            </div>
                            <table width="98%" border="1" cellpadding="0" cellspacing="0" style="word-break:break-all; word-wrap:break-all;">
                                <thead style="display:table-header-group;font-weight:bold">
                                    <tr style="font-size: 16px;font-weight: 600;margin-top: 20px;">
                                      <td>序号</td>
                                      <td>通道编号</td>
                                      <td>包装箱号</td>
                                      <td>订单编号</td>
                                      <td>批次号</td>
                                      <td>物料编号</td>
                                      <td>规值</td>
                                      <td>库位</td>
                                      <td>物料数量</td>
                                      <td>实际数量</td>
                                      <td>盘点人</td>
                                    </tr>
                                </thead>
                                <tr v-for="(item, index) in printList" :key="index">
                                  <td>{{index +1}} </td>
                                  <td>{{item.whCode}}</td>
                                  <td>{{item.boxBarcode}}</td>
                                  <td>{{item.orderCode}}</td>
                                  <td>{{item.batchNo}}</td>
                                  <td>{{item.matCode}}</td>
                                  <td>{{item.matSpecs}}</td>
                                  <td>{{item.laCode}}</td>
                                  <td>{{item.matQuan}}</td>
                                  <td>{{item.matQuanReal}}</td>
                                  <td>{{item.person}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </v-print>
        </el-dialog>

        <el-dialog title="盘点单打印" :visible.sync="printShow1" width="1200px" :close-on-click-modal="false">
            <div style="margin-top:20px;margin-left:800px">
                <el-button class="btn-t-info" type="info" @click="(printShow1 = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow1=false">打印</el-button>
            </div>
            <v-print :doPrint.sync="print">
                <div id="demo" class="demo">
                    <div>
                        <div style="font-size: 42px;font-weight: 600;margin-top: 25px;text-align: center;color: black;">
                            盘点单
                        </div>
                        <div class="table">
                            <div style="margin-left: -950px;font-size:18px;margin-bottom:20px">
                                {{ timeDate }}
                            </div>
                            <table width="98%" border="1" cellpadding="0" cellspacing="0" style="word-break:break-all; word-wrap:break-all;">
                                <thead style="display:table-header-group;font-weight:bold">
                                    <tr style="font-size: 16px;font-weight: 600;margin-top: 20px;">
                                      <td>序号</td>
                                      <td>通道编号</td>
                                      <td>包装箱号</td>
                                      <td>订单编号</td>
                                      <td>批次号</td>
                                      <td>物料编号</td>
                                      <td>规值</td>
                                      <td>库位</td>
                                      <td>物料数量</td>
                                      <td>实际数量</td>
                                      <td>盘点人</td>
                                    </tr>
                                </thead>
                                <tr v-for="(item, index) in printList" :key="index">
                                  <td>{{index +1}} </td>
                                  <td>{{item.whCode}}</td>
                                  <td>{{item.boxBarcode}}</td>
                                  <td>{{item.orderCode}}</td>
                                  <td>{{item.batchNo}}</td>
                                  <td>{{item.matCode}}</td>
                                  <td>{{item.matSpecs}}</td>
                                  <td>{{item.lcCode}}</td>
                                  <td>{{item.matQuan}}</td>
                                  <td>{{item.matQuanReal}}</td>
                                  <td>{{item.person}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </v-print>
        </el-dialog>
    </div>
</template>

<script>
    import confluenceVue from '../reportData/confluence.vue';
    import vPrint from 'syl-vue-printer'
    import moment from "moment";
    export default {
        name: "StockTakeProject",
        components: {
            vPrint
        },
        data() {
            let _this = this;
            return {
                keyValue: 1,
                isShowAddressInfo: true,
                lcCodeType: [],
                props: {
                    multiple: true
                },
                options: [{

                }],

                mainSearch: {
                    fcCode: localStorage.getItem("fcCode") || "",
                    //whCode: localStorage.getItem("whCode") || "",
                    whCode: "",
                    sckCode: "",
                    sckStatus: "",
                    sckType: "",
                    sckTypeSub: "",
                    sckWay: "",
                    date: [],
                },
                whCodeId: "",
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                detailsSearch: {
                    sckCode: "",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    status: "",
                    boxBarcode: "",
                    date: [],
                },
                detailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                //多选
                checkListMain: [],
                checkListDetails: [],

                //编辑框
                updateShow: false,
                updateDialogData: {},

                //详情框
                detailShow: false,

                //新增盘点
                warehouseList: [],
                whInventoryDialog: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                },
                whInventorySearch: {
                    fcCode: localStorage.getItem("fcCode"), // 工厂编号
                    //whCode: localStorage.getItem("whCode") || "", //	通道编号
                    whCode: "",
                    lcCode: "", //	库位编号
                    lcType: "", //  库位类型
                    matCode: "", //	物料编号
                    matName: "", //	物料描述
                    batchNo: "", //	批次号
                    //wiStatus: "NORMAL", //	库存状态
                    wiStatus: "", //	库存状态
                    boxBarcode: "", //	箱号
                    date: [],
                    matCodeList: "", //  物料类型查询的所有物料
                    lcTypeSub: "", //库区位置
                    lcCodeType: "",
                    height: [],//第几层
                },
                whInventoryShow: false,
                checkListWh: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                checkDept: "", //盘点部门
                checkPerson: "", //盘点人员
                checkSckWay: "10", //盘点方式
                checkTime: [], //盘点时间

                reloadCheckShow: false,
                relaodCheckTime: [], //重新盘点时间

                //操作人
                person: localStorage.getItem("user"),
                //操作人工号
                personNumber: localStorage.getItem("empNumber"),
                //库位类型编号
                whCodeType: "LATYPE",
                //库位类型集合
                whCodeTypeList: [],
                //部门类型编号
                deptCodeType: "DEPT",
                //部门类型集合
                deptCodeTypeList: [],
                //用户集合
                userList: [],
                //物料编号集合
                matCodes: [],

                //物料编号loading
                loading: false,
                //远程搜索定时物料编号绑定
                mtCode: "",

                //多选状态数组
                sckStatusList: [],
                //仓库类型集合
                warehouseTypeList: [],
                //盘点位置
                inventoryLocationList: [],
                //物料类型条件
                matType: "MATTYPE",
                //仓库类型条件
                warehouseType: "",
                //物料主数据类型
                mtType: "",
                //物料类型集合
                matTypeList: [],

                optionProps: {
                    expandTrigger: 'hover',
                    //checkStrictly:true,
                    //emitPath:false,
                    multiple: true,
                    lazy: false,
                    lazyLoad: this.loadTechnologyId,
                    //value: 'lmId',
                    value: 'lmRealCode',
                    label: 'lmName',
                    children: 'sysLocationMenuPOList'
                },

                //远程搜索库位集合
                LcCodeList: [],
                //库位Loading
                lcCodeLoading: false,
                //打印窗口
                printShow: false,
                //新增盘点打印窗口
                printShow1: false,
                //打印
                print: false,
                printList: [],
                timeDate: '',

                downloadLoading: false, //下载中
                insertStockCheckTaskByParams: false,
                getStockListLoading: false,
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000)
                },
                deep: true,
            },
            sckStatusList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000)
                },
                deep: true,
            },
            // whInventorySearch: {
            //     handler(newVal) {
            //      clearTimeout(this.isSetTimeout)
            //      this.isSetTimeout = setTimeout(() => {
            //          this.clickSelectDetailList(newVal);
            //          },1000)
            //      },
            //      deep: true,
            // },
            warehouseType: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getLocationMenu();
                    }, 1000)
                },
                deep: true,
            },
            inventoryLocationList(newVal) {
                this.keyValue++ //只要监听到数据源发生变化 ，改变keyValue的值，达到重新渲染的效果
            }
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
            pickerOptions2() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.checkTime[0]) {
                            return time.getTime() < new Date(_this.checkTime[0]);
                        }
                    }
                }
            },
            pickerOptions1() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.checkTime[1]) {
                            return time.getTime() > new Date(_this.checkTime[1]);
                        }
                    }
                }
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getStockCheckTaskList()
                }, 1000)
            },
            /**
             * 获取当前时间
             * 格式YYYY-MM-DD
             */
            getTime() {
                var date = new Date();
                var seperator1 = "/";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                this.timeDate = year + seperator1 + month + seperator1 + strDate;
            },
            printObjList() {
                let code = [];
                for (let i in this.printList) {
                    code.push(this.printList[i].sckCode)
                }
                let stringCode = code.join(",")
                this.$http
                    .request({
                        url: "api/stockPrintDocument/insertStockPrintDocument",
                        method: "POST",
                        showLoading: true,
                        params: {
                            operaCode: stringCode,
                            operaType: '70',
                            fcCode: localStorage.getItem("fcCode") || "",
                            person: localStorage.getItem("user"),
                            personNumber: localStorage.getItem("empNumber"),
                        },
                    })
                    .then((resp) => {})
                    .catch((error) => {});
            },
            /**
             * 新增盘点单打印
             */
            printsSearch(){
                if (this.whInventoryDialog.data.length == 0) {
                    this.$message({
                        message: "请选中查询条件查询出盘点库存数据再进行打印功能！",
                        type: "warning",
                    });
                    return
                }else{
                    this.printsGetStockList()  
                }
            },
            /**
             * 打印查询盘点数据
             */
            printsGetStockList() {
                var height = "";
                this.whInventorySearch.height.forEach((item)=>{
                    height += item + ",";
                });
                this.$http
                    .request({
                        url: "/api/inventory/getStockList",
                        method: "GET",
                        params: {
                            fcCode: this.whInventorySearch.fcCode || null, //	工厂编号
                            whCode: this.whInventorySearch.whCode || null, //	通道编号
                            matCode: this.whInventorySearch.matCode || null, //	物料编号
                            matName: this.whInventorySearch.matName || null, //	物料描述
                            batchNo: this.whInventorySearch.batchNo || null, //	批次号
                            wiStatus: this.whInventorySearch.wiStatus || null, //	库存状态
                            boxBarcode: this.whInventorySearch.boxBarcode || null, //	箱号
                            beginTime: this.whInventorySearch.date ?
                                this.whInventorySearch.date[0] : null,
                            endTime: this.whInventorySearch.date ?
                                this.whInventorySearch.date[1] : null,
                            lcCode: this.whInventorySearch.lcCode || null, //	库位编号
                            lcType: this.whInventorySearch.lcType || null, //   库位类型
                            matCodeList: this.whInventorySearch.matCodeList || null, //物料类型查询的物料编号集合
                            lcTypeSub: this.whInventorySearch.lcTypeSub || null,
                            lcCodeType: this.warehouseType || null,
                            mtType: this.mtType || null,
                            //height: this.whInventorySearch.height.join(","),
                            height:height,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.printList = res.data.list;
                            this.printShow1 = true;    
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 打开打印盘点单窗口
             */
            prints() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择打印单！",
                        type: "warning",
                    });
                    return
                }
                // var sckCode = "";
                // this.checkListMain.forEach((item) => {
                //     sckCode += item.sckCode;
                // })

                let sckCodeList = [];
                this.checkListMain.forEach((item) => {
                    sckCodeList.push(item.sckCode);
                })
                var sckCode = sckCodeList.join(",");

                this.getStockCheckTaskDetailListPrint(sckCode);
                this.getTime()
                // console.log(this.printList)
            },
            getStockCheckTaskDetailListPrint(sckCode) {
                this.$http
                    .request({
                        url: "/api/checkTask/getStockCheckTaskDetailListPrint",
                        method: "GET",
                        params: {
                            sckCode: sckCode || null,
                            matCode: this.detailsSearch.matCode || null,
                            matName: this.detailsSearch.matName || null,
                            batchNo: this.detailsSearch.batchNo || null,
                            fcCode: this.detailsSearch.fcCode || null,
                            status: this.detailsSearch.status || null,
                            boxBarcode: this.detailsSearch.boxBarcode || null,
                            beginTime: this.detailsSearch.date ?
                                this.detailsSearch.date[0] : null,
                            endTime: this.detailsSearch.date ?
                                this.detailsSearch.date[1] : null,
                            // pageNum: this.detailData.nowPage,
                            // pageSize: this.detailData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.total != 0) {
                                this.printList = resp.data.list || [];
                                this.printShow = true;
                            }
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 根据用户工厂编号获取所有的库位
             */
            getSysLocationAll() {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByLcTypeSub",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || null,
                            lcCode: this.whInventorySearch.lcCode || null,
                            lcTypeSub: this.whInventorySearch.lcTypeSub || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.LcCodeList = resp.data.list;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 远程搜索库位号
             */
            remoteMethodLcCode(query) {
                if (query || query == 0) {
                    this.lcCodeLoading = true;

                    this.whInventorySearch.lcCode = query;
                    this.getSysLocationAll();

                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.LcCodeList != undefined) {
                            this.LcCodeList = this.LcCodeList.filter(item => {
                                return item.lcCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.removeLcCodeList = [];
                }
            },
            //清除物料类型
            clearMtType() {
                this.whInventorySearch.matCodeList = "";
            },
            /**
             * 根据仓库类型获取所有货位类型货位号信息
             */
            getLocationMenus() {
                this.$http
                    .request({
                        url: "/api/location/getLocationMenus",
                        method: "GET",
                        params: {
                            lmId: this.warehouseType,
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.total != 0) {
                                this.inventoryLocationList = resp.data.list
                            }
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 根据物料类型获取物料信息
             */
            getMatCodeByType() {
                this.$http
                    .request({
                        url: "/api/material/getMaterialByType",
                        method: "GET",
                        params: {
                            mtType: this.mtType,
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.total != 0) {
                                var matCodes = "";
                                resp.data.list.forEach((item) => {
                                    matCodes += item.mtCode + ","
                                })
                                this.whInventorySearch.matCodeList = matCodes;
                            } else {
                                //假如根据物料类型没有查找到物料设置默认值1
                                if (this.mtType == "") {
                                    this.whInventorySearch.matCodeList = "";
                                } else {
                                    this.whInventorySearch.matCodeList = 1;
                                }
                            }
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 获取所有的物料类型
             */
            getMatTypeAll() {
                this.$http
                    .request({
                        url: "/api/dictData/getMatTypeAll",
                        method: "GET",
                        params: {
                            ddCode: this.matType,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            // console.log(resp.data.list);
                            this.matTypeList = resp.data.list;
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 处理获取所有的货位号
             */
            getInventoryByLcCode() {
                var lcCodeList = ""
                // console.log(this.lcCodeType);
                this.lcCodeType.forEach((item) => {
                    lcCodeList += item[item.length - 1] + ","
                })
                this.whInventorySearch.lcCode = lcCodeList;
            },
            /**
             * 动态加载
             */
            loadTechnologyId(node, resolve) {
                const level = node.level
                const nodes = [];

                var lmId = "";
                var lcType = "";
                if (level == 0) {
                    lmId = this.warehouseType;
                } else if (level == 1) {
                    lmId = node.value
                } else if (level == 2) {
                    lmId = node.data.lmRealCode
                }

                if (level == 0 || level == 1) {
                    this.$http
                        .request({
                            url: "/api/location/getLocationMenu",
                            method: "GET",
                            showLoading: true,
                            params: {
                                lmId: lmId,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                if (resp.data.total != 0) {
                                    resp.data.list.forEach((item) => {
                                        var obj = {
                                            lmId: item.lmId,
                                            lmName: item.lmName,
                                            lmRealCode: item.lmRealCode,
                                            solidFlag: item.solidFlag,
                                            leaf: node.level >= 2
                                        }
                                        // if(item.parentId == 8){
                                        //     obj.leaf = node.level >= 2
                                        // }
                                        nodes.push(obj);
                                    })
                                }

                                resolve(nodes);
                            }
                        })
                } else if (level == 2) {
                    // if (!node.data.solidFlag) {
                    //     lcType = node.data.lmRealCode
                    //     this.$http
                    //         .request({
                    //             url: "/api/location/getLcCodeByShelves",
                    //             method: "GET",
                    // showLoading: true,
                    //             params: {
                    //                 lcType: lcType,
                    //                 fcCode: localStorage.getItem("fcCode") || "",
                    //             },
                    //         })
                    //         .then((resp) => {
                    //             if (resp.status == 100) {
                    //                 if (resp.data.total != 0) {
                    //                     resp.data.list.forEach((item) => {
                    //                         var obj = {
                    //                             lmId: item.lcCode,
                    //                             lmName: item.lcCode,
                    //                             lmRealCode: item.lcCode,
                    //                             solidFlag: item.solidFlag,
                    //                             leaf: node.level >= 2
                    //                         }
                    //                         nodes.push(obj);
                    //                     })
                    //                 }

                    //                 resolve(nodes);
                    //             }
                    //         })
                    // } else if (level == 2) {
                    this.$http
                        .request({
                            url: "/api/location/getLcCodeByShelves",
                            method: "GET",
                            showLoading: true,
                            params: {
                                lcTypeSub: lmId,
                                fcCode: localStorage.getItem("fcCode") || "",
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                if (resp.data.total != 0) {
                                    resp.data.list.forEach((item) => {
                                        var obj = {
                                            lmId: item.lcCode,
                                            lmName: item.lcCode,
                                            lmRealCode: item.lcCode,
                                            solidFlag: item.solidFlag,
                                            leaf: node.level >= 2
                                        }
                                        nodes.push(obj);
                                    })
                                }

                                resolve(nodes);

                            }
                        })
                    // }
                }

            },
            /**
             * 根据选择的盘点位置获取所有的货位号
             */
            getLcCodeByType() {
                var lcCodeList = ""
                this.lcCodeType.forEach((item) => {
                    lcCodeList += item[item.length - 1] + ","
                })
                this.whInventorySearch.lcTypeSub = lcCodeList;
                this.getSysLocationAll();
            },
            /**
             * 根据父级获取所有的子级
             */
            // getLocationMenu(lmId){
            //     this.$http
            //         .request({
            //             url: "/api/location/getLocationMenu",
            //             method: "GET",
            // showLoading: true,
            //             params: {
            //                 lmId: lmId,   
            //             },
            //         })
            //         .then((resp) => {
            //             if (resp.status == 100) {
            //                 this.inventoryLocationList = resp.data.list;
            //             } else {
            //                 this.$message({
            //                     message: resp.message,
            //                     type: "error",
            //                 });
            //             }
            //         })
            //         .catch((error) => {
            //             this.$message({
            //                 message: "操作失败",
            //                 type: "error",
            //             });
            //         });    
            // },
            // getLocationMenu() {
            //     this.$http
            //         .request({
            //             url: "/api/location/getLocationMenu",
            //             method: "GET",
            // showLoading: true,
            //             params: {
            //                 lmId: this.warehouseType,
            //             },
            //         })
            //         .then((resp) => {
            //             if (resp.status == 100) {
            //                 if (resp.data.total != 0) {
            //                     if (this.warehouseType) {
            //                         this.getLocationMenus();
            //                     } else {
            //                         this.lcCodeType = []
            //                         this.inventoryLocationList = [];
            //                         this.lcTypeSub = "";
            //                     }
            //                 } else {
            //                     //如果根据仓库类型没有找到货位号的话，设置默认值为1，如果是清空文本框的话就给""
            //                     this.lcCodeType = []
            //                     this.inventoryLocationList = [];
            //                 }
            //             } else {
            //                 this.$message({
            //                     message: resp.message,
            //                     type: "error",
            //                 });
            //             }
            //         })
            //         .catch((error) => {
            //             this.$message({
            //                 message: "操作失败",
            //                 type: "error",
            //             });
            //         });
            // },
            getLocationMenu() {
                if (this.warehouseType) {
                    //this.getLcTypeSubByType();
                    this.getLocationMenus();
                } else {
                    this.lcCodeType = []
                    this.inventoryLocationList = [];
                    this.whInventorySearch.lcTypeSub = "";
                    this.whInventorySearch.lcCodeType = "";
                }
            },
            /**
             * 根据仓库类型获取所有的库区位置
             */
            getLcTypeSubByType() {
                this.$http
                    .request({
                        url: "/api/location/getLcCodeByLocationMenuType",
                        method: "GET",
                        params: {
                            lmId: this.warehouseType,
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.whInventorySearch.lcCodeType = resp.data;
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 根据仓库类型查询所有的货位号
             */
            // getLcCodeAllByType() {
            //     this.$http
            //         .request({
            //             url: "/api/location/getLcCodeByLocationMenuType",
            //             method: "GET",
            // showLoading: true,
            //             params: {
            //                 lmId: this.warehouseType,
            //                 fcCode: localStorage.getItem("fcCode") || "",
            //             },
            //         })
            //         .then((resp) => {
            //             if (resp.status == 100) {
            //                 if (resp.data.total != 0) {
            //                     var lcCodeList = "";
            //                     resp.data.list.forEach((item) => {
            //                         lcCodeList += item.lcCode + ","
            //                     })
            //                     this.whInventorySearch.lcCodeList = lcCodeList;
            //                 } else {
            //                     this.whInventorySearch.lcCodeList = "";
            //                 }
            //                 //this.inventoryLocationList = resp.data.list;
            //             } else {
            //                 this.$message({
            //                     message: resp.message,
            //                     type: "error",
            //                 });
            //             }
            //         })
            //         .catch((error) => {
            //             this.$message({
            //                 message: "操作失败",
            //                 type: "error",
            //             });
            //         });
            // },
            /**
             * 根据工厂编号查询仓库类型
             */
            getWarehouseType() {
                this.$http
                    .request({
                        url: "/api/location/getWarehouseType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.total != 0) {
                                this.warehouseTypeList = resp.data.list;
                            } else {
                                this.warehouseTypeList = []
                            }
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 重置新增盘点数据
             */
            reset() {
                this.whInventoryDialog = {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                }
            },
            //删除盘点的箱号
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            /**
             * 远程搜索物料编号
             */
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;

                    this.whInventorySearch.matCode = query;
                    this.getSysMaterial();

                    setTimeout(() => {
                        this.loading = false;
                        if (this.matCodes != undefined) {
                            this.matCodes = this.matCodes.filter(item => {
                                return item.mtCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.matCodes = [];
                }
            },
            /**
             * 根据工厂编号查询所有的物料编号
             */
            getSysMaterial() {
                // this.$http
                //     .request({
                //         url: "/api/material/getMaterialAll",
                //         method: "GET",
                // showLoading: true,
                //         params: {
                //             fcCode: localStorage.getItem("fcCode") || "",
                //         },
                //     })
                //     .then((resp) => {
                //         if (resp.status == 100) {
                //             this.matCodes = resp.data.list;
                //         } else {
                //             this.$message({
                //                 message: resp.message,
                //                 type: "error",
                //             });
                //         }
                //     })
                //     .catch((error) => {
                //         this.$message({
                //             message: "操作失败",
                //             type: "error",
                //         });
                //     });
                this.$http
                    .request({
                        url: "/api/material/getMaterials",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            mtCode: this.whInventorySearch.matCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.matCodes = resp.data.list;
                            // this.logRemarks = "checkTask：查询物料编号操作成功";
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                            // this.logRemarks = "checkTask：查询物料编号操作失败";
                        }
                        //this.logContent = "sckCodes：" + sckCodes;
                        // this.systemLog();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 根据工厂编号查询所有的物料编号
             */
            // getSysMaterial() {
            //     this.$http
            //         .request({
            //             url: "/api/material/getMaterialAll",
            //             method: "GET",
            // showLoading: true,
            //             params: {
            //                 fcCode: localStorage.getItem("fcCode") || "",
            //             },
            //         })
            //         .then((resp) => {
            //             if (resp.status == 100) {
            //                 this.matCodes = resp.data.list;
            //                 this.logRemarks = "checkTask：查询物料编号操作成功";
            //             } else {
            //                 this.$message({
            //                     message: resp.message,
            //                     type: "error",
            //                 });
            //                 this.logRemarks = "checkTask：查询物料编号操作失败";
            //             }
            //             //this.logContent = "sckCodes：" + sckCodes;
            //             this.systemLog();
            //         })
            //         .catch((error) => {
            //             this.$message({
            //                 message: "操作失败",
            //                 type: "error",
            //             });
            //         });
            // },
            //清除库位类型
            change() {
                this.whInventorySearch.lcCode = "";
            },
            /**
             * 获取所有的用户
             */
            getUserList() {
                this.$http
                    .request({
                        url: "/api/user/userAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode"),
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.userList = resp.data.list;
                            this.logRemarks = "checkTask：查询用户操作成功";
                        } else {
                            this.logRemarks = "checkTask：查询用户操作失败";
                        }
                        // this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                        // this.systemLog();
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 根据库位类型查询所有的库位 
             */
            // getWhCodeAllByType(ddCode) {
            //     this.$http
            //         .request({
            //             url: "/api/location/getLaCodeAllByType",
            //             method: "GET",
            // showLoading: true,
            //             params: {
            //                 fcCode: localStorage.getItem("fcCode") || "",
            //                 lcType: ddCode,
            //             },
            //         })
            //         .then((resp) => {
            //             if (resp.status == 100) {
            //                 if (resp.data.total != 0) {
            //                     var lcCode = "";
            //                     resp.data.list.forEach((item) => {
            //                         lcCode += item.lcCode + ","
            //                     })
            //                     this.whInventorySearch.lcCode = lcCode.substring(0, lcCode.length - 1)
            //                 } else {
            //                     this.whInventorySearch.lcCode = "null";
            //                     this.mainData.data = [];
            //                     this.$message({
            //                         message: "该区暂无库位",
            //                         type: "warning",
            //                     });
            //                 }

            //             }
            //         })
            //         .catch((error) => {
            //             this.$message({
            //                 message: "操作失败",
            //                 type: "error",
            //             });
            //         });
            // },
            /**
             * 获取所有的部门类型
             */
            getDeptCodeTypeList() {
                this.$http
                    .request({
                        url: "/api/dict/getDictTypeByLatypeAll",
                        method: "GET",
                        params: {
                            dtCode: this.deptCodeType
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.deptCodeTypeList = resp.data.list;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 获取所有的库位类型
             */
            getWhCodeTypeList() {
                this.$http
                    .request({
                        url: "/api/dict/getDictTypeByLatypeAll",
                        method: "GET",
                        params: {
                            dtCode: this.whCodeType
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.whCodeTypeList = resp.data.list;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 计划下发
             */
            planDistribution() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请勾选盘点计划！",
                        type: "warning",
                    });
                    return;
                }

                if (this.checkListMain.length > 1) {
                    this.$message({
                        message: "只能选择一个盘点计划！",
                        type: "warning",
                    });
                    return;
                }

                if (this.checkListMain[0].sckStatus != 'CREATE') {
                    this.$message({
                        message: "只能对创建状态的盘点计划进行下发！",
                        type: "warning",
                    });
                    return;
                }

                this.$confirm("是否开始下发盘点计划?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/startExecutionTask",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    sckCode: this.checkListMain[0].sckCode,
                                    person: localStorage.getItem("user") || "",
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点下发开始执行操作成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点下发开始执行操作失败";
                                }
                                this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                                this.systemLog();
                                this.getStockCheckTaskList();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 取消下发
             */
            cancelDistribution() {

                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请勾选盘点计划！",
                        type: "warning",
                    });
                    return;
                }

                if (this.checkListMain.length > 1) {
                    this.$message({
                        message: "只能选择一个盘点计划！",
                        type: "warning",
                    });
                    return;
                }

                if (this.checkListMain[0].sckStatus != 'LSSUED') {
                    this.$message({
                        message: "只能对已下发状态的盘点计划取消下发！",
                        type: "warning",
                    });
                    return;
                }

                this.$confirm("是否开始取消下发的盘点计划?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/cancelDistribution",
                                method: "PUT",
                                showLoading: true,
                                params: {
                                    sckCode: this.checkListMain[0].sckCode,
                                    person: localStorage.getItem("user") || "",
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点取消下发操作成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点取消下发操作失败";
                                }
                                this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                                this.systemLog();
                                this.getStockCheckTaskList();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });

            },
            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.mainData.nowPage = 1;
                this.getStockCheckTaskList(newVal);
            },
            /**
             * 查询盘点计划
             */
            getStockCheckTaskList() {
                let status = "";
                //this.mainSearch.sckStatus = "";
                this.sckStatusList.forEach((item) => {
                    status += item + ","
                })
                //this.mainSearch.sckStatus.substring(0,this.mainSearch.sckStatus.length-1)
                // if (this.mainSearch.whCode == "") {
                //   this.whCodeId = localStorage.getItem("whCode") || "";
                // } else {
                //   this.whCodeId = this.mainSearch.whCode;
                // }
                this.$http
                    .request({
                        url: "/api/checkTask/getStockCheckTaskList",
                        method: "GET",
                        params: {
                            // person: localStorage.getItem("user") || "",
                            fcCode: this.mainSearch.fcCode || null,
                            sckCode: this.mainSearch.sckCode || null,
                            whCode: this.mainSearch.whCode || null,
                            sckStatus: status || null,
                            sckType: this.mainSearch.sckType || null,
                            sckTypeSub: this.mainSearch.sckTypeSub || null,
                            sckWay: this.mainSearch.sckWay || null,
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                            pageNum: this.mainData.nowPage,
                            pageSize: this.mainData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData.data = resp.data.list || [];
                            this.mainData.data.forEach((item) => {
                                if (item.sckTime != undefined) {
                                    item.sckTime = item.sckTime.replaceAll(",", "~")
                                }
                            })
                            this.mainData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 根据工厂编号查询所有的通道
             */
            getSysWarehouseAll() {
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getSysWarehouseAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data;
                            this.updateDialogData = resp.data;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 编辑
             */
            updateDialog() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                }
                if (this.checkListMain.length > 1) {
                    this.$message({
                        message: "有且只能选择一个盘点计划",
                        type: "warning",
                    });
                    return;
                }
                this.updateShow = true;
                this.updateDialogData = this.checkListMain[0];
            },
            updateStockCheckTask() {
                this.$confirm("是否确认编辑盘点计划?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/updateStockCheckTask",
                                method: "PUT",
                                showLoading: true,
                                data: this.updateDialogData,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点计划编辑成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点计划编辑失败";
                                }
                                this.logContent = JSON.stringify(this.updateDialogData);
                                this.systemLog();
                                this.updateClose();
                                this.getStockCheckTaskList();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            updateClose() {
                this.updateShow = false;
                this.updateDialogData = {};
                this.getStockCheckTaskList();
            },

            /**
             * 删除
             */
            deleteStockCheckTask() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择盘点计划",
                        type: "warning",
                    });
                    return;
                }

                // this.checkListMain.forEach(element => {
                //     if (element.sckStatus != 'CREATE') {
                //         this.$message({
                //             message: "只能删除还未执行的计划",
                //             type: "warning",
                //         });
                //         return;
                //     }
                // });
                for (let i in this.checkListMain) {
                    if (this.checkListMain[i].sckStatus != 'LSSUED') {
                        this.$message({
                            message: "只能删除刚下发的盘点计划",
                            type: "warning",
                        });
                        return;
                    }
                }
                this.$confirm("是否删除盘点计划?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let sckIds = "";
                        this.checkListMain.forEach((element) => {
                            sckIds = sckIds + element.sckId + ",";
                        });

                        this.$http
                            .request({
                                url: "/api/checkTask/deleteStockCheckTask",
                                method: "DELETE",
                                params: {
                                    sckIds: sckIds,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点计划删除成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点计划删除失败";
                                }
                                this.logContent = "sckIds：" + sckIds;
                                this.systemLog();
                                this.getStockCheckTaskList();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            // 点击查询按钮 重置页号
            clickSelectDetailList(newVal) {
                this.whInventoryDialog.nowPage = 1;
                this.getStockList(newVal);
            },
            /**
             * 查询盘点计划明细
             */
            getStockCheckTaskDetailList() {
                this.$http
                    .request({
                        url: "/api/checkTask/getStockCheckTaskDetailList",
                        method: "GET",
                        params: {
                            sckCode: this.detailsSearch.sckCode || null,
                            matCode: this.detailsSearch.matCode || null,
                            matName: this.detailsSearch.matName || null,
                            batchNo: this.detailsSearch.batchNo || null,
                            fcCode: this.detailsSearch.fcCode || null,
                            status: this.detailsSearch.status || null,
                            boxBarcode: this.detailsSearch.boxBarcode || null,
                            beginTime: this.detailsSearch.date ?
                                this.detailsSearch.date[0] : null,
                            endTime: this.detailsSearch.date ?
                                this.detailsSearch.date[1] : null,
                            pageNum: this.detailData.nowPage,
                            pageSize: this.detailData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.total != 0) {
                                this.detailData.data = resp.data.list || [];
                                this.detailData.total = resp.data.total;
                            }
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 详情
             */
            rowDetail(sckCode) {
                this.detailShow = true;
                this.detailsSearch.sckCode = sckCode;
                this.getStockCheckTaskDetailList();
            },
            detailClose() {
                this.detailShow = false;
                this.resetDetail();
                // this.getStockCheckTaskList();
            },

            /**
             * 多选
             */
            checkTableMain(val) {
                this.checkListMain = val;
            },
            checkAllWh(val) {
                this.checkListWh = val;
            },
            /**
             * 禁选
             */
            // checkboxMain(row, rowIndex) {
            //     if (row.sckStatus == 'CREATE' || row.sckStatus == 'EXECUTE') {
            //         return true // 不禁用
            //     } else {
            //         return false // 禁用
            //     }
            //     return true;
            // },
            /**
             * 重置
             */
            resetMain() {
                this.mainSearch = {
                    fcCode: localStorage.getItem("fcCode") || "",
                    //whCode: localStorage.getItem("whCode") || "",
                    sckCode: "",
                    sckStatus: "",
                    sckType: "",
                    sckTypeSub: "",
                    sckWay: "",
                    date: [],
                };
                this.sckStatusList = [];
            },
            resetDetail() {
                this.detailsSearch = {
                    sckCode: "",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    status: "",
                    boxBarcode: "",
                    date: [],
                };
            },
            resetStock() {
                this.whInventorySearch = {
                    fcCode: localStorage.getItem("fcCode"), // 工厂编号
                    //whCode: localStorage.getItem("whCode") || "", // 通道编号
                    whCode: "", // 通道编号
                    lcCode: "", // 库位编号
                    lcType: "", // 库位类型
                    matCode: "", // 物料编号
                    matName: "", // 物料描述
                    batchNo: "", // 批次号
                    //wiStatus: "NORMAL", // 库存状态
                    wiStatus: "", // 库存状态
                    boxBarcode: "", // 箱号
                    date: [],
                    matCodeList: "",
                    lcCodeType: "",
                    height: [],
                };
            },
            /**
             * 重置新增盘点条件
             */
            resetInsertWhInventory() {
                this.resetStock();
                this.reset();
                this.checkDept = "";
                this.checkPerson = "";
                this.checkTime = [];
                this.mtType = "";
                this.lcCodeType = [];
                this.warehouseType = "";
            },

            //新增盘点计划
            whInventoryOpen() {
                this.getWarehouseType();
                this.getSysLocationAll();
                this.setTime();
                this.getMatTypeAll();
                //this.getWhCodeTypeList();
                this.getDeptCodeTypeList();
                this.getUserList();
                this.getSysMaterial();
                //this.whInventoryDialog.data = [];
                this.reset();
                //this.getWarehouse();
                //this.getStockList();
                this.whInventoryShow = true;
            },
            /**
             * 设置盘点开始日期和结束日期
             */
            setTime(){
                var day1 = new Date();
                day1.setTime(day1.getTime());
                this.checkTime[0] = day1.getFullYear()+"-" + ((day1.getMonth()+1)>10?(day1.getMonth()+1):("0"+(day1.getMonth()+1))) + "-" + day1.getDate() + " 00:00";
                var day2 = new Date();
                day2.setTime(day2.getTime()+24*60*60*1000);
                this.checkTime[1] = day2.getFullYear()+"-" + ((day2.getMonth()+1)>10?(day1.getMonth()+1):("0"+(day1.getMonth()+1))) + "-" + day2.getDate() + " 00:00";
                console.log(this.checkTime[1])
            },
            whInventoryClose() {
                this.whInventoryShow = false;
                this.resetStock();
                this.reset();
                this.checkDept = "";
                this.checkPerson = "";
                this.checkTime = [];
                this.mtType = "";
                this.lcCodeType = [];
                this.warehouseType = "";
                this.warehouseTypeList = [];
            },

            //库存列表
            getStockList() {
                this.getStockListLoading = true;
                var height = "";
                this.whInventorySearch.height.forEach((item)=>{
                    height += item + ",";
                });
                this.$http
                    .request({
                        url: "/api/inventory/getStockList",
                        method: "GET",
                        params: {
                            pageNum: this.whInventoryDialog.nowPage, //	页号
                            pageSize: this.whInventoryDialog.pageSize, //	页大小
                            fcCode: this.whInventorySearch.fcCode || null, //	工厂编号
                            whCode: this.whInventorySearch.whCode || null, //	通道编号
                            matCode: this.whInventorySearch.matCode || null, //	物料编号
                            matName: this.whInventorySearch.matName || null, //	物料描述
                            batchNo: this.whInventorySearch.batchNo || null, //	批次号
                            wiStatus: this.whInventorySearch.wiStatus || null, //	库存状态
                            boxBarcode: this.whInventorySearch.boxBarcode || null, //	箱号
                            beginTime: this.whInventorySearch.date ?
                                this.whInventorySearch.date[0] : null,
                            endTime: this.whInventorySearch.date ?
                                this.whInventorySearch.date[1] : null,
                            lcCode: this.whInventorySearch.lcCode || null, //	库位编号
                            lcType: this.whInventorySearch.lcType || null, //   库位类型
                            matCodeList: this.whInventorySearch.matCodeList || null, //物料类型查询的物料编号集合
                            lcTypeSub: this.whInventorySearch.lcTypeSub || null,
                            lcCodeType: this.warehouseType || null,
                            mtType: this.mtType || null,
                            // height: this.whInventorySearch.height.join(",") //第几层
                            height: height,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.whInventoryDialog.data = res.data.list;
                            this.whInventoryDialog.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                        this.getStockListLoading = false
                    });
            },

            /**
             * 盘点——查询条件
             */
            insertStockCheckTaskByParam() {
                if (this.whInventoryDialog.data.length == 0) {
                    this.$message({
                        message: "没有可盘点的物料！",
                        type: "warning",
                    });
                    return;
                } 
                var searchTime = "";
                if (this.checkTime.length > 0) {
                    searchTime = this.checkTime[0] + "," + this.checkTime[1];
                }
                this.$confirm("是否进行盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.insertStockCheckTaskByParams = true;
                        var height = "";
                        this.whInventorySearch.height.forEach((item)=>{
                            height += item + ",";
                        });
                        this.$http
                            .request({
                                url: "/api/checkTask/insertStockCheckTaskByList",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    fcCode: localStorage.getItem("fcCode") || null, //	工厂编号
                                    whCode: this.whInventorySearch.whCode || null, //	通道编号
                                    lcCode: this.whInventorySearch.lcCode || null, //   库位编号
                                    matCode: this.whInventorySearch.matCode || null, //	物料编号
                                    matName: this.whInventorySearch.matName || null, //	物料描述
                                    batchNo: this.whInventorySearch.batchNo || null, //	批次号
                                    wiStatus: this.whInventorySearch.wiStatus || null, //	库存状态
                                    boxBarcode: this.whInventorySearch.boxBarcode || null, //	箱号
                                    beginTime: this.whInventorySearch.date ?
                                        this.whInventorySearch.date[0] : null,
                                    endTime: this.whInventorySearch.date ?
                                        this.whInventorySearch.date[1] : null,
                                    sckPerson: this.checkPerson,
                                    sckDept: this.checkDept,
                                    sckTime: searchTime,
                                    sckWay: this.checkSckWay,
                                    person: this.person,
                                    personNumber: this.personNumber,
                                    //matCodeList: this.whInventorySearch.matCodeList,
                                    lcTypeSub: this.whInventorySearch.lcTypeSub || null,
                                    warehouseType: this.warehouseType || null,
                                    mtType: this.mtType || null,
                                    //height: this.whInventorySearch.height.join(",")
                                    height:height,
                                },
                                data: this.whInventoryDialog.data,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "新增盘点计划成功！",
                                        type: "success",
                                    });
                                    this.logRemarks =
                                        "checkTask：盘点计划（查询盘点）确认将所有的查询结果进行盘点操作成功";
                                    this.whInventoryClose();
                                    this.getStockCheckTaskList();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks =
                                        "checkTask：盘点计划（查询盘点）确认将所有的查询结果进行盘点操作失败";
                                }
                                this.insertStockCheckTaskByParams = false;
                                this.logContent = JSON.stringify(this.whInventorySearch);
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.insertStockCheckTaskByParams = false;
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.insertStockCheckTaskByParams = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            /**
             * 盘点——勾选
             */
            insertStockCheckTaskByList() {
                if (this.checkListWh.length == 0) {
                    this.$message({
                        message: "请勾选库存！",
                        type: "warning",
                    });
                    return;
                }
                this.$confirm("是否确认将已选择的库存进行盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/insertStockCheckTaskByList",
                                method: "POST",
                                showLoading: true,
                                data: this.checkListWh,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks =
                                        "checkTask：盘点计划（勾选盘点）确认将已选择的库存进行盘点操作成功";
                                    this.whInventoryClose();
                                    this.getStockCheckTaskList();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks =
                                        "checkTask：盘点计划（勾选盘点）确认将已选择的库存进行盘点操作成功";
                                }
                                this.logContent = JSON.stringify(this.checkListWh);
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            // clickReloadTask() {
            //     if (this.checkListMain.length == 0) {
            //         this.$message({
            //             message: "请选择盘点计划",
            //             type: "warning",
            //         });
            //         return;
            //     }
            //     if (this.checkListMain.length > 1) {
            //         this.$message({
            //             message: "有且只能选择一个盘点计划",
            //             type: "warning",
            //         });
            //         return;
            //     }

            //     this.reloadCheckShow = true;
            // },

            /**
             * 重新盘点
             */
            reloadCheckTask() {
                var searchTime = "";
                if (this.relaodCheckTime.length > 0) {
                    searchTime = this.relaodCheckTime[0] + "," + this.relaodCheckTime[1];
                }

                this.$confirm("是否重新盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/reloadCheckTask",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    sckCode: this.checkListMain[0].sckCode,
                                    sckTime: searchTime,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "checkTask：盘点计划（重新盘点）";
                                    this.reloadCheckShow = false;
                                    this.getStockCheckTaskList();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "checkTask：盘点计划（重新盘点）";
                                }
                                this.logContent = "sckCode：" + this.checkListMain[0].sckCode;
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            //表格导出
            downLoadFile() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择需要导出的盘点记录！",
                        type: "warning",
                    });
                    return
                }
                this.downloadLoading = true;
                let sckCodeList = [];
                for (let i in this.checkListMain) {
                    sckCodeList.push(this.checkListMain[i].sckCode);
                }
                let sckCode = sckCodeList.join(",");

                var paramsObj = {
                    sckCode: sckCode || null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/checkTask/getStockCheckTaskDetailList',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    if(resp.data.total != 0 && resp.status == 100){
                        resp.data.list.forEach((item)=>{
                            if(item.status == 'EXECUTE'){
                                item.matQuanReal = "";
                            }
                        })
                    }
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.status == 'LSSUED') {
                            c['status'] = '已下发'
                        } else if (c.status == 'EXECUTE') {
                            c['status'] = '进行中'
                        } else if (c.status == 'HANDLE') {
                            c['status'] = '待处理'
                        } else if (c.status == 'COMPLETE') {
                            c['status'] = '完成'
                        } else if (c.status == 'PROCESSED') {
                            c['status'] = '完成'
                        } else if (c.status == 'CLOSE') {
                            c['status'] = '关闭'
                        }

                    })
                    const tHeader = ['通道编号', '库位编号', '盘点单号', '物料编号', '物料描述', '物料数量', '实际数量', '批次号', '状态', '箱号', '订单编号',
                        '规值', '创建时间', '盘点人'
                    ]
                    const filterVal = ['whCode', 'laCode', 'sckCode', 'matCode', 'matName', 'matQuan', 'matQuanReal', 'batchNo', 'status', 'boxBarcode', 'orderCode',
                        'matSpecs', 'createTime', 'person'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '盘点计划单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_check_task：导出盘点计划记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "盘点计划",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.getSysWarehouseAll();
            /* 获取首页的数据 */
            this.getStockCheckTaskList();
        },
    };
</script>

<style scoped>
    .table {
        margin-left: 30px;
        margin-bottom: 80px;
        margin-top: 30px;
        text-align: center;
        color: black;
    }

    .demo {
        border: 1px solid white;

    }
</style>